import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.trim.js";
import { navigateToDownloadPage } from '../../utils/navigateToDownloadPage';

/**
 * 微信开放标签 `wx-open-launch-app`（DOM 注入，避免 Vue 编译器处理内层 `wxtag-template`）
 * @see https://developers.weixin.qq.com/doc/service/guide/h5/opentag.html
 */
export default {
  name: 'WechatOpenLaunchApp',
  props: {
    /** 微信开放平台移动应用 AppID */
    appId: {
      type: String,
      required: true
    },
    /** 透传给 App（OpenSDK messageExt），一般为 JSON 字符串 */
    extinfo: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: 'App内打开'
    },
    /** 与页面 `.open-btn` 视觉对齐的简化样式 */
    variant: {
      type: String,
      default: 'pill',
      validator: function validator(v) {
        return ['pill', 'cta'].includes(v);
      }
    },
    /** 唤起 App 失败时是否跳转下载页 */
    redirectToDownloadOnError: {
      type: Boolean,
      default: true
    }
  },
  emits: ['launch', 'error', 'ready'],
  watch: {
    appId: function appId() {
      this.mountTag();
    },
    extinfo: function extinfo() {
      this.mountTag();
    },
    buttonText: function buttonText() {
      this.mountTag();
    }
  },
  mounted: function mounted() {
    this.mountTag();
  },
  beforeUnmount: function beforeUnmount() {
    this.teardownTag();
  },
  methods: {
    teardownTag: function teardownTag() {
      var host = this.$refs.host;
      if (!host) return;
      host.innerHTML = '';
      this._wxTag = null;
    },
    mountTag: function mountTag() {
      var _this = this;
      if (!this.appId) return;
      this.teardownTag();
      var host = this.$refs.host;
      if (!host) return;
      var tag = document.createElement('wx-open-launch-app');
      tag.setAttribute('appid', this.appId);
      tag.setAttribute('extinfo', this.extinfo || '');
      var tmpl = document.createElement('script');
      tmpl.type = 'text/wxtag-template';
      var btnClass = this.variant === 'cta' ? 'wx-o-btn wx-o-btn--cta' : 'wx-o-btn wx-o-btn--pill';
      tmpl.innerHTML = "<style>\n          .wx-o-btn { border: none; padding: 0; margin: 0; font-family: inherit; cursor: pointer; box-sizing: border-box; }\n          .wx-o-btn--pill {\n            height: 46px; width: 170px; border-radius: 60px;\n            background: linear-gradient(76deg, #C52F20 0%, #CF4436 50%, #F0A837 100%);\n            color: #fff; font-size: 16px; font-weight: 800;\n            display: flex; align-items: center; justify-content: center;\n          }\n          .wx-o-btn--cta {\n            min-width: 200px; height: 48px; padding: 0 24px; border-radius: 24px;\n            background: linear-gradient(76deg, #C52F20 0%, #CF4436 50%, #F0A837 100%);\n            color: #fff; font-size: 16px; font-weight: 800;\n            display: flex; align-items: center; justify-content: center;\n          }\n        </style>\n        <button type=\"button\" class=\"".concat(btnClass, "\">").concat(this.buttonText, "</button>").trim();
      tag.appendChild(tmpl);
      tag.addEventListener('ready', function (e) {
        console.log('[wxOpenLaunchApp] ready', {
          appId: _this.appId,
          extinfoLength: String(_this.extinfo || '').length
        });
        _this.$emit('ready', e);
      });
      tag.addEventListener('launch', function (e) {
        console.log('[wxOpenLaunchApp] launch', (e === null || e === void 0 ? void 0 : e.detail) || null);
        _this.$emit('launch', e);
      });
      tag.addEventListener('error', function (e) {
        console.error('[wxOpenLaunchApp] error', (e === null || e === void 0 ? void 0 : e.detail) || e);
        _this.$emit('error', e);
        if (_this.redirectToDownloadOnError) {
          navigateToDownloadPage(_this.$router);
        }
      });
      host.appendChild(tag);
      this._wxTag = tag;
    }
  }
};